<template>
  <div
    :class="[
      $style.container,
      $style[`container--size-${size}`],
    ]"
    @click="$emit('click')"
  >
    <div
      v-if="getProjectImage"
      :class="$style.logo"
      :style="getStyle"
    ></div>
    <div
      v-else
      :class="$style.empty"
    >
      {{ getFirstChar }}
    </div>
  </div>
</template>

<script>
import { inArray } from 'lib/component/validators';

export default {
  name: 'ProjectLogo',
  props: {
    project: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      validator: inArray(['sm', 'md', 'lg']),
      default: 'md',
    },
  },
  computed: {
    getProjectImage() {
      const { attachment } = this.project;

      if (this.$validate.isNull(attachment)) {
        return null;
      }

      if (!this.$validate.isObjectWithFields(attachment, ['link'])) {
        return null;
      }

      // TODO: добавить проверку на корректный URL
      return attachment.link;
    },
    getFirstChar() {
      const { name } = this.project;

      if (this.$validate.isNotString(name)) {
        return null;
      }

      return name.charAt(0);
    },
    getStyle() {
      return { backgroundImage: `url(${this.getProjectImage})` };
    },
  },
};
</script>

<style lang="sass" module>
  .container
    border-radius: 50px
    background-color: #181722
    overflow: hidden

    $sizes: (sm, 20, 12), (md, 40, 16), (lg, 60, 36)

    @each $key, $size, $fontSize in $sizes
      &--size-#{$key}
        width: #{$size}px
        height: #{$size}px
        min-width: #{$size}px

        .empty
          +font-type('regular', $fontSize)

  .logo
    +size(100%)
    background-repeat: no-repeat
    background-position: center
    background-size: cover

  .empty
    +flexbox
    +justify-content(center)
    +align-items(center)
    +size(100%)
    color: var(--color-white)
    text-transform: uppercase
</style>
